import A from './actionTypes';
import Gravestones from '../../public/data/gravestones.json';

export function selectGravestone(d) {
  return (dispatch, getState) => {
    let id = d;
    if (d && d.id) {
      ({ id} = d);
    }

    dispatch({
      type: A.SELECT_GRAVESTONE,
      payload: id,
    });

    // recenter if necessary
    const { lat, lng } = getState().gravestones.find(g => g.id === id);
    const { bounds } = getState();
    const { n, s, e, w } = _getNSWE(bounds);

    if (lat <= s || lat >= n || lng <= w || lng >= e) {
      dispatch(changeCenterAndZoom([lat, lng], 20));
    }
  };
}

export function unselectGravestone() {
  return {
    type: A.SELECT_GRAVESTONE,
    payload: null,
  };
}

export function changeCenterAndZoom(center, zoom) {
  return {
    type: A.CHANGE_CENTER_AND_ZOOM,
    payload: {
      center,
      zoom,
    },
  };
}

export function changeBounds(bounds) {
  return {
    type: A.CHANGE_BOUNDS,
    payload: bounds,
  };
}

export function loadGravestones() {
  return async (dispatch) => {
    // const query = 'select birth_day, birth_month, birth_year, death_day, death_month, death_year, findgrave_id, findgrave_id as id, first_name, last_name, latitude, longitude, maiden_name, middle_name from gravestones_materialized where latitude != 37.535835 or longitude != -77.385079';
    // const url = `https://digitalscholarshiplab.cartodb.com/api/v2/sql?format=JSON&q=${encodeURI(query)}`;
    // console.log(url);
    // const response = await fetch(url);
    // const json = await response.json();
    //const gravestones = json.rows.map((r) => {
    const gravestones = Gravestones.map(r => {
      const { nf: first_name, nm: middle_name, nl: last_name, by: birth_year, dy: death_year } = r;
      r.searchName = `${first_name} ${(typeof middle_name !== 'undefined') ? middle_name : ''} ${last_name} (${(birth_year !== 0) ? birth_year : ''}-${death_year})`;
      return r;
    });

    dispatch({
      type: A.LOAD_GRAVESTONES,
      payload: gravestones,
    });
  };
}

export function toggleAbout() {
  return {
    type: A.TOGGLE_ABOUT,
  };
}

export function toggleHillshade() {
  return {
    type: A.TOGGLE_HILLSHADE,
  };
}



export function toggleContactUs() {
  return {
    type: A.TOGGLE_CONTACT_US,
  };
}

export function geolocate() {
  return (dispatch, getState) => {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((position) => {
        // only select from position if a city isn't specified, a location isn't specified
        dispatch({
          type: A.LOCATED_USER,
          payload: [position.coords.latitude, position.coords.longitude],
        });
      }, (error) => {
        console.warn(`geolocation error ${error}`);
      }, {
        enableHighAccuracy: true,
        timeout: 7500,
        maximumAge: 100000,
      });
    }
  };
}

export function zoomToHeadstone(eOrId) {
  const id = _getEventId(eOrId, 'number');
  return (dispatch, getState) => {
    const { lat, lng } = getState().gravestones.find(g => g.id === id);
    dispatch(changeCenterAndZoom([lat, lng], 22));
  };
}

function _getEventId(eOrId, type = 'string') {
  let id = eOrId.id || eOrId;
  if (!eOrId.id && typeof eOrId === 'object') {
    const ct = eOrId.currentTarget || eOrId.target;
    id = ct.id || ct.options.id;
  }
  return (type === 'number') ? parseInt(id, 10) : id;
}

function _getNSWE(bounds) {
  return {
    n: Math.max(bounds[0][0], bounds[1][0]),
    s: Math.min(bounds[0][0], bounds[1][0]),
    e: Math.max(bounds[0][1], bounds[1][1]),
    w: Math.min(bounds[0][1], bounds[1][1]),
  };
}



// WEBPACK FOOTER //
// ./src/store/actions.js